import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

interface FolderNavigationProps {
  currentFolder: { id: number; name: string } | null;
  onBackClick: () => void;
}

export function FolderNavigation({
  currentFolder,
  onBackClick,
}: FolderNavigationProps) {
  if (!currentFolder) return null;

  return (
    <div className="flex items-center space-x-2 mb-4">
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={onBackClick}
        className="text-blue-600 hover:bg-blue-50 hover:text-black"
      >
        <ChevronLeft className="h-4 w-4 mr-1" />
        Back to All Folders
      </Button>
      <span className="text-muted-foreground">/</span>
      <span className="font-medium">{currentFolder.name}</span>
    </div>
  );
}

